import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import CashierList from "./CashierList";
import CashierShow from "./CashierShow";
import CashierEdit from "./CashierEdit";
import CashierCreate from "./CashierCreate";

export const cashier = {
  list: CashierList,
  show: CashierShow,
  edit: CashierEdit,
  create: CashierCreate,
  icon: ManageAccountsIcon,
  options: { label: "ra.users.cashier.title" },
};
